import React from 'react';
import PropTypes from 'prop-types';

import postal from 'postal';
import updateWireFeaturedContributors from '../../../../services/wire/featured-contributor-service';

export default class WireFeaturedContributorsControl extends React.Component {
  static propTypes = {
    wireId: PropTypes.number.isRequired,
  }

  constructor(props, context) {
    super(props, context);
    postal.subscribe({
      channel: 'editor',
      topic: 'wire-body-saved',
      callback: this.updateFeaturedContributors.bind(this),
    });
  }

  updateFeaturedContributors() {
    const id = `#wire-featured-contributors-${this.props.wireId}`;
    updateWireFeaturedContributors(this.props.wireId)
      .then(response => {
        document.querySelector(id).innerHTML = response.data;
      });
  }

  render() {
    const id = `wire-featured-contributors-${this.props.wireId}`;
    const urlValue = `/hotwired/wires/${this.props.wireId}/featured_contributors`;
    return (
      <div
        id={id}
        data-controller="fetch"
        data-fetch-url-value={urlValue}
        data-fetch-auto-fetch-value
      />
    );
  }
}
